<template>
  <div class="wrapper">
    <div class="titleSpan">
    <h2>
      <el-link icon="el-icon-arrow-left" @click="goTo('paperInterviewList') "></el-link>
      面试详情    {{tableData[3].value}}
    </h2>
    </div>

    <div class="tableData">
      <div class="flex-table">
        <div class="flex-item" v-for="(item, index) in tableData" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>

    </div>



  </div>
</template>


<script>
import {
  getPaperInterviewDetail,
} from "@/api/paper.js";

export default {
  data() {
    return {
      tableData: [
        {title: '论文名称', value: ''},
        {title: '考生姓名', value: ''},
        {title: '论文分组', value: ''},
        {title: '状态', value: ''},
        {title: '评分人', value: ''},
        {title: '最终成绩', value: ''},
        {title: '分数', value: ''},
        {title: '面试时间', value: ''},
      ],

    };
  },
  created() {

  },
  mounted() {
    this.getPaperInterviewDetail();
  },
  methods: {
    getPaperInterviewDetail() {
      let params = {
        id: this.$route.query.id,
      };
      getPaperInterviewDetail(params).then((data) => {
        console.log("data", data);
        let infoData = this.tableData;
        infoData[0].value = data.paperName;
        infoData[1].value = data.userName;
        infoData[2].value = data.paperGroupName;
        infoData[3].value = data.interviewResult;
        infoData[4].value = data.auditTeacher;
        infoData[5].value = data.score;
        infoData[6].value = data.scoreString;
        infoData[7].value = data.reverseTime;
        this.tableData = infoData;

      });
    },

    goTo(url) {
      this.$router.push({name: url});
    },
  }
};
</script>

<style scoped lang="less">
.wrapper {

  font-size: 12px;
  margin: 15px;

.titleSpan{
  background: #fff;
  padding: 20px;
  margin-bottom: 5px;
}

  .tableData {
    background: #fff;
    padding: 20px;

    .flex-table {
      display: flex;
      flex-wrap: wrap;
    }

    .flex-table .flex-item {
      flex: 0 0 50%;
      display: flex;
      align-items: center;
      height: 40px;
      font-size: 16px;
      box-sizing: border-box;
    }

    .flex-table .flex-item:nth-child(1) .title {
      border-top: 1px solid #ccc;
    }

    .flex-table .flex-item:nth-child(1) .value {
      border-top: 1px solid #ccc;
    }

    .flex-table .flex-item:nth-child(2) .title {
      border-top: 1px solid #ccc;
    }

    .flex-table .flex-item:nth-child(2) .value {
      border-top: 1px solid #ccc;
    }

    .flex-table .flex-item:nth-child(2n) .title {
      border-left: none;
    }

    .flex-table .flex-item .title {
      display: flex;
      align-items: center;
      height: 40px;
      padding: 0 10px;
      width: 150px;
      background-color: #f5f5f5;
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      border-left: 1px solid #ccc;
    }

    .flex-table .flex-item .value {
      flex: 1;
      display: flex;
      align-items: center;
      height: 40px;
      padding: 0 10px;
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      background-color: #fff;
    }

    　　.infoTable {
      font-size: 12px;
      color: #71787E;
      border-collapse: collapse;
      text-align: center;
      padding-top: 20px;
    }

    　　.infoTable tr td {
      border: 1px solid #E6EAEE;
      width: 200px;
      height: 35px;
      line-height: 35px;
      box-sizing: border-box;
      padding: 0 10px;
    }

    　　.infoTable tr td.column {
      background-color: #EFF3F6;
      color: #393C3E;
    }
  }

}
</style>
